// Turns the engine health payload from GET /argostraderbot/dashboard into what
// the "Ticker Health" / "Book Health" cards display. Age-based, so a live
// stream shows a small duration and a stalled one is obvious, never a bare 0.

export function engineValue(engine) {
    // No payload yet means the first load is still in flight.
    if (!engine) return '—';
    if (!engine.ok) return 'STALE';
    const seconds = Math.round((engine.marketEventAgeMs || 0) / 1000);
    return seconds < 60 ? `${seconds}s` : `${Math.round(seconds / 60)}m`;
}

export function engineBackground(engine) {
    return engine ? (engine.ok ? 'success' : 'danger') : undefined;
}
